// extracted by mini-css-extract-plugin
export default {"displayUIWrapper":"display_UI_adapter_displayUIWrapper__RZe+v","certificatsContainer":"display_UI_adapter_certificatsContainer__Zte2c"};